<template>
  <span :contenteditable="editable" ref="editName" id="editable-name"
        name="editable-name" data-testid="editable-name"
        @keydown.enter="submitName($event)" @blur="updateName"></span>
</template>

<script>
  export default {
    props: {
      item: { type: Object, required: true },
      isOwner: { type: Boolean, required: true },
      forcedName: { type: String, required: false, default: null }
    },
    mounted: function(){
      this.$refs.editName.innerText = this.displayName;
    },
    watch: {
      displayName: function() {
        this.$refs.editName.innerText = this.displayName;
      }
    },
    data: function() {
      return {
        name: this.item.attributes.name_without_extension
      }
    },
    computed: {
      displayName: function() {
        return (this.forcedName || this.name || "");
      },
      editable: function() {
        if (!this.$store.state.currentOrganization.id) return false; // Organization info not (yet) loaded.

        const view_only = this.$store.state.currentOrganization.attributes.current_user_view_only;
        return (this.isOwner && (!view_only));
      }
    },
    methods: {
      submitName(event) {
        event.target.blur();
        event.preventDefault();
      },
      updateName: function(){
        const name = this.$refs.editName.innerText.trim();

        if(name.length > 0) {
          this.$store.dispatch('updateItem', { itemId: this.item.id, body: { name: name + this.item.attributes.file_ext }});
        } else {
          this.name = this.item.attributes.name_without_extension;
          this.$refs.editName.innerText = this.displayName;
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  #name{
    display: none;
  }

  #editable-name {
    outline: none;
    border: 0;
    background: transparent;
    font-size: 12px;
    font-weight: 600;
  }
</style>
